import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-73d9477d")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (!_ctx.to)
    ? (_openBlock(), _createBlock("button", {
        key: 0,
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
        class: ["button-primary", { 'disabled': _ctx.disabled || _ctx.internalDisable }],
        disabled: _ctx.disabled || _ctx.internalDisable,
        type: _ctx.type,
        "aria-label": _ctx.ariaLabel
      }, _toDisplayString(_ctx.text), 11, ["disabled", "type", "aria-label"]))
    : (_ctx.to)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          class: ["button-primary", { 'disabled': _ctx.disabled }],
          type: _ctx.type,
          "aria-label": _ctx.ariaLabel,
          to: _ctx.to
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.text), 1)
          ]),
          _: 1
        }, 8, ["class", "type", "aria-label", "to"]))
      : _createCommentVNode("", true)
})